import { useAuthBearerFetch } from "matsuri-hooks"
import { m2mCleaning_cleanerV3 } from "@/endpoints/m2m-cleaning.cleaner-v3"

type HasErrand = boolean

export type HasErrandsByOperationIdsOutput = Record<
    string, // cleaningId,
    HasErrand
>

export const useHasErrandsByOperationIds = (
    token: string,
    operationIds: string[]
) => {
    const endpoint = m2mCleaning_cleanerV3.hasErrands
    return useAuthBearerFetch<HasErrandsByOperationIdsOutput>(
        token,
        operationIds.length > 0 ? endpoint() : null,
        {
            body: JSON.stringify({
                cleaningIds: operationIds
            }),
            method: endpoint.method
        }
    )
}
